import { tns } from 'tiny-slider/src/tiny-slider';

const tnsPress = document.querySelectorAll('.press-slider');
if (tnsPress) {
	tnsPress.forEach((slider) => {
		const tnsSlider = tns({
			container: slider,
			items: 1,
			speed: 500,
			nav: false,
			mouseDrag: true,
			arrowKeys: true,
			autoplayButtonOutput: false,
			controlsText: [
				"<span class='screen-reader-text'>Prev</span>",
				"<span class='screen-reader-text'>Next</span>",
			],
		});
	});
}

const tnsContent = document.querySelectorAll('.content-slider');
if (tnsContent) {
	tnsContent.forEach((slider) => {
		const tnsSlider = tns({
			container: slider,
			items: 1,
			speed: 500,
			nav: false,
			mode: 'gallery',
			loop: true,
			autoplay: false,
			autoplayTimeout: 4000,
			mouseDrag: true,
			arrowKeys: true,
			autoplayButtonOutput: false,
			controlsText: [
				"<span class='screen-reader-text'>Prev</span>",
				"<span class='screen-reader-text'>Next</span>",
			],
		});
	});
}

const tnsProductSpec = document.querySelectorAll('.slider--product-specs');
if (tnsProductSpec) {
	tnsProductSpec.forEach((slider) => {
		const tnsSlider = tns({
			container: slider,
			items: 1,
			speed: 500,
			navContainer: '#product-spec-thumbnails',
			loop: true,
			autoplay: false,
			autoplayTimeout: 4000,
			mouseDrag: true,
			arrowKeys: true,
			autoplayButtonOutput: false,
			controlsText: [
				"<span class='screen-reader-text'>Prev</span>",
				"<span class='screen-reader-text'>Next</span>",
			],
		});
	});
}
